<template>
  <div id="partner-business">
    <div class="sm-title mb-30">
      <h3>Të dhënat e partnerit</h3>
    </div>

    <div class="w-100">
      <form enctype="multipart/form-data">
        <div class="form-group d-md-flex mb-3 w-100">
          <div class="flex flex-column w-100 pr-md-2">
            <input
                class="mb-0 w-100"
                type="text"
                name="kompania"
                placeholder="kompania"
                :value="company_name"
                @input="getCompanyName"
                required
            />
            <p v-if="getErrors.company_name" class="text-danger m-0">
              <i class="fa fa-exclamation-circle"></i>
              <small class="pl-2">Shkruani emrin kompanise</small>
            </p>
          </div>
          <div class="flex flex-column w-100 pl-md-2 mt-3 mt-md-0">
            <input
                class="mb-0 w-100"
                type="number"
                name="business_nr"
                placeholder="numri i biznesit"
                :value="business_number"
                @input="getBusinessNumber"
                required
            />
            <p v-if="getErrors.business_number" class="text-danger m-0">
              <i class="fa fa-exclamation-circle"></i>
              <small class="pl-2">Shkruani numrin e biznesit</small>
            </p>
          </div>
        </div>

        <div class="form-group d-md-flex mb-3 w-100">
          <div class="flex flex-column w-100 pr-md-2">
            <input
                class="mb-0 w-100"
                type="email"
                placeholder="e-mail"
                name="c_email"
                :value="email"
                @input="getEmail"
            />
            <p v-if="getErrors.email" class="text-danger m-0">
              <i class="fa fa-exclamation-circle"></i>
              <small class="pl-2">Emaili duhet te jete unik ne formatin "example@example.com"</small>
            </p>
          </div>
          <div class="flex flex-column w-100 pl-md-2 mt-3 mt-md-0">
            <input
                class="mb-0 w-100"
                type="number"
                name="phone_nr"
                placeholder="nr i telefonit"
                :value="phone"
                @input="getPhoneNumber"
                required
            />
            <p v-if="getErrors.phone" class="text-danger m-0">
              <i class="fa fa-exclamation-circle"></i>
              <small class="pl-2">Shkruani numrin e telefonit</small>
            </p>
          </div>
        </div>

        <div class="form-group d-md-flex mb-3 w-100">
          <div class="flex flex-column w-100 pr-md-2">
            <input
                class="mb-0 w-100"
                name="c_address"
                type="text"
                placeholder="adresa"
                :value="address"
                @input="getAddress"
                required
            />
            <p v-if="getErrors.address" class="text-danger m-0">
              <i class="fa fa-exclamation-circle"></i>
              <small class="pl-2">Shkruani adresen!</small>
            </p>
          </div>
          <div class="flex flex-column w-100 pl-md-2 mt-3 mt-md-0">
            <input
                class="mb-0 w-100"
                name="c_address"
                type="text"
                placeholder="zona operimit"
                :value="operation_zone"
                @input="getOperationZone"
                required
            />
            <p v-if="getErrors.operation_zone" class="text-danger m-0">
              <i class="fa fa-exclamation-circle"></i>
              <small>Shkruani zonen e operimit</small>
            </p>
          </div>
        </div>

        <div class='form-group'>
          <span id="input-id-photos" class="btn btn-light btn-file w-100 p-3">
            <small>Foto certif. biznesit (.jpg, .png, .jpeg)</small>
            <input
                class="w-100"
                accept="image/png, image/jpg, image/jpeg"
                @change="updatePersonalPhotos"
                type="file"
                name="id_photo"
                multiple/>
          </span>

          <p v-if="getErrors.id_photos" class="text-danger m-0">
            <i class="fa fa-exclamation-circle"></i>
            <small class="pl-2">Ngarko foto te certifikates biznesit (.jpg, .jpeg, .png)</small>
          </p>
          <ul class="mt-3">
            <li class="mb-2" v-for="photo in photos" :key="photo.id">
              {{ photo.name }} - <a class="text-danger" @click="removePersonalPhoto(photo.name)">Fshije</a>
            </li>
          </ul>
        </div>

        <div class="w-100 mt-4 mt-md-8">
          <h3 class="mb-3">Të dhënat e automjetit të punës</h3>
          <div class="form-group" v-for="(vehicle, i) in vehicles" :key="i">
            <div class="add-cancel">
              <p>{{ find_index(vehicles, i) }}.</p>
              <a v-if="find_index(vehicles, i) >= 2" @click="removeVehicleAt(i, $event)">
                <i class="fas fa-times"></i>
              </a>
            </div>
            <hr/>

            <div class="form-group d-md-flex mb-3 w-100">
              <div class="flex flex-column w-100 pr-md-2">
                <input
                    class="mb-0 w-100"
                    type="text"
                    placeholder="targat e automjetit"
                    @input="updateRegistrationNr(i, $event)"
                    :value="vehicles[i].vehicle_registration"
                    required
                />
                <p v-if="getArrayErrorMessages(getErrors, i, 'vehicles', 'vehicle_registration')"
                   class="text-danger m-0">
                  <i class="fa fa-exclamation-circle"></i>
                  <small class="pl-2">Shkruani targen e automjetit (deri 15 karaktere)</small>
                </p>
              </div>

              <div class="flex flex-column w-100 pl-md-2 mt-3 mt-md-0">
                <select
                    class="mb-0 w-100"
                    @change="updateCarType(i, $event)"
                    :value="vehicles[i].vehicle_model"
                >
                  <option disabled value>Zgjedh llojin e automjetit</option>
                  <option
                      v-for="brand in brandNames"
                      :key="brand"
                      :value="brand"
                      :disabled="brand === ''"
                  >{{ brand }}
                  </option>
                </select>
                <p v-if="getArrayErrorMessages(getErrors, i, 'vehicles', 'vehicle_model')" class="text-danger m-0">
                  <i class="fa fa-exclamation-circle"></i>
                  <small class="pl-2">Zgjedh modelin e automjetit</small>
                </p>
              </div>
            </div>

            <div class="form-group d-md-flex mb-3 w-100">
              <div class="flex flex-column w-100">
                <select
                    class="mb-0 w-100"
                    @change="updateRegistrationYear(i, $event)"
                    :value="vehicles[i].vehicle_year"
                >
                  <option value disabled>Zgjedh vitin e prodhimit</option>
                  <option
                      v-for="year in yearsList"
                      :key="year"
                      :value="year"
                  >{{ year }}
                  </option>
                </select>
                <p v-if="getArrayErrorMessages(getErrors, i, 'vehicles', 'vehicle_year')" class="text-danger m-0">
                  <i class="fa fa-exclamation-circle"></i>
                  <small class="pl-2">Zgjedh vitin e automjetit</small>
                </p>
              </div>
            </div>

            <div class="flex flex-column w-100">
              <span id="input-vehicle-photo" class="btn btn-light btn-file w-100 p-3">
                <small>Foto te automjetit (.jpg, .png, .jpeg)</small>
                <input class="w-100"
                       accept="image/png, image/jpg, image/jpeg"
                       @change="updateVehiclePhoto(i, $event)"
                       type="file"
                       name="vehicle_photo"
                       multiple
                />
                </span>

              <p v-if="getArrayErrorMessages(getErrors, i, 'vehicles', 'vehicle_photos')"
                 class="text-danger m-0">
                <i class="fa fa-exclamation-circle"></i>
                <small class="pl-2">Ngarko foto te automjetit (.png, .jpeg, .jpg)</small>
              </p>
              <ul class="mt-3">
                <li class="mb-2" v-for="photo in getVehicles[i].vehicle_photos" :key="photo.name">
                  {{ photo.name }} - <a class="text-danger" @click="removeVehiclePhoto(i, photo.name)">Fshije</a>
                </li>
              </ul>
            </div>
          </div>
          <button
              class="add-car mt-2"
              @click="getVehicleCount(1, $event)"
          >+ Shto automjet tjeter
          </button>
        </div>
      </form>
      <p class="text-center text-success mt-4" v-if="getFormSuccess">Kerkesa juaj u dergua me sukses</p>
      <p class="text-center text-danger mt-4" v-if="getErrors.length !== 0"><small>Ka ndodhur nje gabim, ju lutem plotesoni te gjitha fushat dhe provoni perseri!</small></p>
    </div>
    <div class="btn-next mt-5">
      <button class="border-0 register-button" :disabled="getDisableButton" @click="registerPartnerBusiness">Vazhdo
      </button>
    </div>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import {yearsList} from "../yearsList";

export default {
  name: "PartnerFormBusiness",
  data() {
    return {
      yearsList: yearsList,
      fileTypes: ['image/jpeg', 'image/jpg', 'image/png'],
      photos: [],
      vehiclePhotos: [],
      errors: [],
    }
  },
  created: function () {
    this.$store.dispatch('partnersForm/getCompanyName', "");
    this.$store.dispatch('partnersForm/getBusinessNumber', "");
    this.$store.dispatch('partnersForm/getPhoneNumber', "");
    this.$store.dispatch('partnersForm/getPersonalId', "");
    this.$store.dispatch('partnersForm/getAddress', "");
    this.$store.dispatch('partnersForm/getOperationZone', "");
    this.$store.dispatch('partnersForm/getIdPhotos', []);
    this.$store.dispatch('partnersForm/getPartnerBusinessFormErrors', []);
  },
  methods: {
    removePersonalPhoto(name) {
      this.photos = this.photos.filter((img) => {
        return img.name !== name
      });

      this.$store.dispatch("partnersForm/getIdPhotos", this.photos);
    },
    updatePersonalPhotos(payload, e) {
      for (let i = 0; i < payload.target.files.length; i++) {

        const doesPhotoExist = this.photos.some(el => el.name === payload.target.files[i].name);

        if(!doesPhotoExist && this.fileTypes.includes(payload.target.files[i].type)) {
          this.photos.push(payload.target.files[i]);
        }
      }
      this.$store.dispatch("partnersForm/getIdPhotos", this.photos);
    },
    removeVehiclePhoto(id, name) {
      this.vehiclePhotos = this.getVehicles[id].vehicle_photos;

      this.vehiclePhotos = this.vehiclePhotos.filter((img) => {
        return img.name !== name
      });

      this.$store.dispatch("partnersForm/updateVehiclePhotos", {
        index: id,
        value: this.vehiclePhotos
      });
      this.vehiclePhotos = [];
    },
    updateVehiclePhoto(payload, e) {
      this.vehiclePhotos = Object.values(this.getVehicles[payload].vehicle_photos);

      for (let i = 0; i < e.target.files.length; i++) {

        const doesPhotoExist = this.vehiclePhotos.some(el => el.name === e.target.files[i].name);

        if(!doesPhotoExist && this.fileTypes.includes(e.target.files[i].type)) {
          this.vehiclePhotos.push(e.target.files[i]);
        }
      }
      this.$store.dispatch("partnersForm/updateVehiclePhotos", {
        index: payload,
        value: this.vehiclePhotos
      });
      this.vehiclePhotos = [];
    },
    getArrayErrorMessages(array, index, type, key) {
      let tempErrors = [];
      Object.keys(array).forEach((e, i) => {
        if (e.startsWith(type.toLowerCase() + '.' + index + '.' + key)) {
          tempErrors.push(array[e])
        }
      })
      if (tempErrors.length !== 0) {
        return tempErrors[0];
      }
    },
    registerPartnerBusiness(e) {
      e.preventDefault();

      this.$store.dispatch('partnersForm/registerPartnerBusiness');
    },
    getCompanyName(e) {
      this.$store.dispatch("partnersForm/getCompanyName", e.target.value);
    },
    getBusinessNumber(e) {
      this.$store.dispatch("partnersForm/getBusinessNumber", e.target.value);
    },
    getEmail(e) {
      this.$store.dispatch("partnersForm/getEmail", e.target.value);
    },
    getPhoneNumber(e) {
      this.$store.dispatch("partnersForm/getPhoneNumber", e.target.value);
    },
    getPersonalId(e) {
      this.$store.dispatch("partnersForm/getPersonalId", e.target.value);
    },
    getAddress(e) {
      this.$store.dispatch("partnersForm/getAddress", e.target.value);
    },
    getOperationZone(e) {
      this.$store.dispatch("partnersForm/getOperationZone", e.target.value);
    },
    getIdPhotos(e) {
      this.$store.dispatch("partnersForm/getIdPhotos", e.target.value);
    },
    find_index(vehicles, j) {
      let result = 0;
      let index = 0;
      $.each(vehicles, function (key, value) {
        if (Number(key) === Number(j)) {
          result = index;
        } else {
          index++;
        }
      });
      return result + 1;
    },
    removeVehicleAt(value, e) {
      e.preventDefault();
      this.$store.dispatch("partnersForm/removeVehicleAt", value);
    },
    getVehicleCount(value, e) {
      e.preventDefault();
      this.$store.dispatch("partnersForm/getVehicleCount", value);
    },
    updateRegistrationNr(payload, e) {
      this.$store.dispatch("partnersForm/updateRegistrationNr", {
        index: payload,
        value: e.target.value
      });
    },
    updateCarType(payload, e) {
      this.$store.dispatch("partnersForm/updateCarType", {
        index: payload,
        value: e.target.value
      });
    },
    updateRegistrationYear(payload, e) {
      this.$store.dispatch("partnersForm/updateRegistrationYear", {
        index: payload,
        value: e.target.value
      });
    },
  },
  computed: {
    ...mapGetters({
      brandNames: "billing/brandNames",
      vehicles: "partnersForm/vehicles",
      first_name: "partnersForm/first_name",
      last_name: "partnersForm/last_name",
      email: "partnersForm/email",
      phone: "partnersForm/phone",
      address: "partnersForm/address",
      operation_zone: "partnersForm/operation_zone",
      business_number: "partnersForm/business_number",
      company_name: "partnersForm/company_name",
      personal_id: "partnersForm/personal_id",
      vehicle_registration: "partnersForm/vehicle_registration",
      vehicle_model: "partnersForm/vehicle_model",
      vehicle_year: "partnersForm/vehicle_year",
      vehicle_count: "partnersForm/vehicle_count",
      vehicle_photos: "partnersForm/vehicle_photos",
      id_photos: "partnersForm/id_photos",
    }),
    getErrors() {
      return this.$store.state.partnersForm.partnerBusinessFormErrors;
    },
    getDisableButton() {
      return this.$store.state.partnersForm.disable_button;
    },
    getFormSuccess() {
      return this.$store.state.partnersForm.form_success;
    },
    getVehicles() {
      return this.$store.state.partnersForm.vehicles;
    }
  }
}
</script>